
import './inputs.css'
import { Tooltip, } from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css'
import BoxInfo from '../BoxInfo'
import { forwardRef } from 'react'
const InputNesting = forwardRef((props, ref) => {

    const {
        onChange,
        onFocus,
        onClick,
        className="",
        labelClass = '',
        id,
        style,
        disabled=false,
        value = "",
        label=true,
        type = "text",
        title = "",
        tooltip = false,
        tooltipText = "",
        boxInfo = false,
        containerClass = "",
        contentStyle,
        placeholder = "",
        defaultValue= ""
     } = props;

    return (

        <div className={`${containerClass} content-inputs`} style={contentStyle}>
            {tooltip && <Tooltip anchorSelect={`#${id}`} content={tooltipText} place="top" />}
            {boxInfo ? <BoxInfo
                id={id}
                titleClass='mr-0-4'
                title={title}
                place="top" 
                containerClass='mr-0-5'
                content={tooltipText}
            /> :
               label &&
                <label className={`${labelClass} label-input`}>
                    {title}
                </label>
            }
            <input
                ref={ref}
                id={id}
                type={type}
                onChange={onChange}
                className={`input-n ${className}`}
                placeholder={placeholder}
                onClick={onClick}
                onFocus={onFocus}
                disabled={disabled}
                // value={value}
                defaultValue={defaultValue}
                style={style}
            />
        </div>

    )

})


const TextareaNesting = forwardRef((props, ref) => {

    const {
        onChange,
        onFocus,
        onClick,
        className,
        labelClass = '',
        id,
        style,
        value = "",
        type = "text",
        title = "",
        tooltip = false,
        tooltipText = "",
        boxInfo = false,
        containerClass = "",
        placeholder = "",
        defaultValue= "",
        row=1
     } = props;

    return (

        <div className={`${containerClass} content-inputs`}>
            {tooltip && <Tooltip anchorSelect={`#${id}`} content={tooltipText} place="top" />}
            {boxInfo ? <BoxInfo
                id={id}
                titleClass='mr-0-4'
                title={title}
                place="top" 
                containerClass='mr-0-5'
                content={tooltipText}
            /> :
                <label className={`${labelClass} label-input`}>
                    {title}
                </label>
            }
            <textarea
                ref={ref}
                id={id}
                rows={row}
                type={type}
                onChange={onChange}
                className={`input-n   ${className}`}
                placeholder={placeholder}
                onClick={onClick}
                onFocus={onFocus}
                // value={value}
                style={style}
                defaultValue={defaultValue}
            />
        </div>

    )

})


export {
    InputNesting,
    TextareaNesting
}